import { render, staticRenderFns } from "./GSuggestionNoticeBox.vue?vue&type=template&id=da087bb6&scoped=true&"
import script from "./GSuggestionNoticeBox.vue?vue&type=script&lang=ts&"
export * from "./GSuggestionNoticeBox.vue?vue&type=script&lang=ts&"
import style0 from "./GSuggestionNoticeBox.vue?vue&type=style&index=0&id=da087bb6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da087bb6",
  null
  
)

export default component.exports